import React, { useEffect, useState } from 'react';
import './CloudPortal.css';
// import './uploadCsvFile.css'
import DeleteMediaDialog from './deleteMedia/deleteMediaDialog';
import {
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import Storage from './Storage';
import httpService from '../../../services/http.service';
import SuccessMessage from '../../common/successMsg';
import ErrorMessage from '../../common/errorMsg';
import Loader from '../../common/loader';
import { FaFileAlt, FaFolder, FaTrash } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';

const isDocFile = (file) => /\.(pptx|pdf|docx?|txt)$/i.test(file.name);
const isImageFile = (file) => /\.(jpg|jpeg|png|gif)$/i.test(file.name);
const isAudioFile = (file) => /\.(mp3|wav)$/i.test(file.name);
const NasDrive = ({ spaceLimit, reloadsub, nassubdata }) => {
    const NasUser = localStorage.getItem('UserId')
    const userRole = localStorage.getItem("CloudUserType")
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])
    const [selectDeleteFile, setSelectDeleteOpen] = useState(null) // Set delete file name
    const [folderStructure, setFolderStructure] = useState([])
    const [openFolderName, setOpenFolderName] = useState('')
    const [fileSizeDetails, setFileSizeDetails] = useState({
        totalSize: 0,
        docSize: 0,
        imageSize: 0,
        audioSize: 0
    })

    const getNasFile = async () => {
        setLoading(true)
        try {
            let { data } = await httpService.get(`/show-user-bucket-files?userID=${NasUser}`)
            setFiles(data.files)
            console.log(data.files, "Data files")
            organizeFilesByFolder(data.files)
            const obj = {
                totalSize: 0,
                docSize: 0,
                imageSize: 0,
                audioSize: 0
            }


            if (userRole === "property_user")
                data.propertyManagerData.forEach((ele, index) => {
                    obj.totalSize = obj.totalSize + ele.size
                    if (isDocFile(ele))
                        obj.docSize = obj.docSize + ele.size
                    else if (isImageFile(ele))
                        obj.imageSize = obj.imageSize + ele.size
                    else if (isAudioFile(ele))
                        obj.audioSize = obj.audioSize + ele.size
                })
            else {
                data.files.forEach((ele, index) => {
                    obj.totalSize = obj.totalSize + ele.size
                    if (isDocFile(ele))
                        obj.docSize = obj.docSize + ele.size
                    else if (isImageFile(ele))
                        obj.imageSize = obj.imageSize + ele.size
                    else if (isAudioFile(ele))
                        obj.audioSize = obj.audioSize + ele.size
                })
            }
            setFileSizeDetails(obj)

        } catch (error) {
            ErrorMessage("Something went wrong")
        }
        finally {
            setLoading(false)
        }

    };

    function organizeFilesByFolder(files) {
        const structure = [];
        files.forEach(file => {
            const path = file.name.split('/').filter(Boolean).slice(userRole === "property_user" ? 2 : 1);
            console.log(path, "path")
            const name = path[0];
            const isFolder = path.length > 1;

            const existing = structure.find(item => item.name === name);

            if (isFolder) {
                if (existing) {
                    existing.fileCount++;
                    existing.size += file.size;
                } else {
                    structure.push({ name, type: 'folder', size: file.size, fileCount: 1 });
                }
            } else {
                structure.push({ name, type: 'files', size: file.size });
            }
        });
        console.log(333, structure)
        setFolderStructure(structure)
    }

    console.log(folderStructure, " : folderStructure")

    useEffect(() => {
        if (!selectDeleteFile) {
            reloadsub()
            getNasFile();
        }
    }, [selectDeleteFile])


    const handleDeleteFile = async (file) => {
        setLoading(true)
        console.log(file)

        try {
            let { data } = await httpService.CreateUpdate(`/delete-google-storage-files?userID=${NasUser}`, { name: file.folderName ? `${file.folderName}/${file.name}` : file.name, size: file.size, isFolder: file.type === 'folder' })
            if (data.ack === "1") {
                SuccessMessage("This item deleted successfully")
                setSelectDeleteOpen(null)
            }
        } catch (error) {
            ErrorMessage("Something went wrong")
        } finally {
            setLoading(false)
        }
    };

    const toggleFolder = (folderName) => {
        if (folderName === openFolderName)
            setOpenFolderName('')
        else
            setOpenFolderName(folderName)

    };

    const FilesRow = ({ file }) => {
        const isFolder = file?.type === 'folder';
        const isOpen = openFolderName === file.name;
        const [folderFiles, setFolderFiles] = useState([])
        useEffect(() => {
            if (isFolder) {
                const tempFolderfiles = files.filter(ele => ele.name.includes(file.name))
                setFolderFiles(tempFolderfiles.map(ele => ({ ...ele, folderName: file.name, name: ele.name.split('/').at(-1) })))
            }
        }, [])
        return <>
            <tr key={file.name} >
                <td className="">
                    <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingLeft: file.folderName ? 36 : 16 }}>
                        {isFolder && (
                            <span onClick={() => toggleFolder(file.name)} style={{ cursor: 'pointer' }}>
                                {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
                            </span>
                        )}
                        {isFolder ? <FaFolder /> : <FaFileAlt />}
                        <span>{file.name}</span>
                    </div>
                </td>
                <td className="">{file?.fileCount ?? '--'}</td>
                <td className="">
                    {file.size / 1e6 < 1
                        ? `${(file.size / 1e3).toFixed(2)} KB`
                        : `${(file.size / 1e6).toFixed(2)} MB`}
                </td>
                <td className="">
                    <span
                        onClick={() => setSelectDeleteOpen(file)}
                        className="cursor-pointer text-red-500 hover:text-red-700"
                    >
                        <FaTrash color='red' cursor={"pointer"} size={16} />
                    </span>
                </td>
            </tr>
            {(isOpen && folderFiles.length > 0) &&
                folderFiles.map(ele => <FilesRow file={ele} />)}
        </>
    }





    return (
        <div>
            {loading ? <Loader /> : <div className="form-boxdiv2">
                <div className="form-boxtopline5">
                    MANAGE YOUR RCC GOOGLE CLOUD STORAGE
                </div>
                <div className="cloud-portal">

                    <div className="main-content">
                        <div className="files-section">
                            <div className="file-controls ">
                                <div className="sort-by">
                                    <h3>Files</h3>
                                </div>
                            </div>
                            <div className='file-list-boxdiv2'>
                                <table className="file-list">
                                    <thead>
                                        <tr className='list-head'>
                                            <th>Files/Folders Name</th>
                                            <th>File Count</th>
                                            <th>Size</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {folderStructure.map(file => (
                                            <>
                                                <FilesRow file={file} />
                                            </>
                                        ))}
                                        <Modal isOpen={selectDeleteFile} toggle={() => setSelectDeleteOpen(null)}>
                                            <ModalHeader toggle={() => setSelectDeleteOpen(null)}><strong>Alert!</strong></ModalHeader>
                                            <ModalBody>
                                                <DeleteMediaDialog onClose={() => setSelectDeleteOpen(null)} onClick={() => handleDeleteFile(selectDeleteFile)} />
                                            </ModalBody>
                                        </Modal>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <Storage spaceLimit={nassubdata.nasSpace} inputRef={getNasFile} {...fileSizeDetails} nassubdata={nassubdata} folderStructure={folderStructure} />
                    </div>
                </div>
            </div>}
        </div>
    );
};
export default NasDrive;